import { createSlice } from "@reduxjs/toolkit";
import {
    hasParentRegistration,
    p2pSettings,
    categories as initialCategories,
} from "../initialState";

// -------------------------------------------------------------------------
// TODO: This is tricky and needs to live somewhere else, either BE or another
// directory. It will be moved once I can see if it still works. The preferred
// place this logic should happen is on the BE. These are all values we know
// ahead of time. Some filtering was moved to the BE already. Need to check
// if all these conditions were covered and it can be removed.
// -------------------------------------------------------------------------

const eventLevelCategoryFilter = () => {
    // Receipts do not have category of p2pSettings sent in initialState
    // early return of empty object to block errors
    if (!Array.isArray(initialCategories)) {
        return [];
    }
    if (initialCategories?.length === 0) {
        return initialCategories;
    }

    const { enableIndividualRegistration, enableTeams } = p2pSettings;
    const allCategories = initialCategories;

    // Filters out Categories that are team Captain only or Primary only when
    // there is a parent registration.  This means we are technically registering an
    // additional registrant even though the registration is in the 0 index
    if (hasParentRegistration) {
        const subregistrantsAllowed = allCategories.filter((category) => {
            if (
                category.attachSubregistrants &&
                (category.attachTeamMembers || category.attachIndividual)
            ) {
                return true;
            }
            return false;
        });
        return subregistrantsAllowed;
    }

    // Don't need to filter out when both settings are true
    if (enableIndividualRegistration && enableTeams) {
        return initialCategories;
    }

    // filter out teams without attachIndividual
    if (enableIndividualRegistration && !enableTeams) {
        const individualAllowed = allCategories.filter(
            (category) => category.attachIndividual === true,
        );
        return individualAllowed;
    }

    // filter out teams without attachTeamMembers or attachTeamCaptains
    if (!enableIndividualRegistration && enableTeams) {
        const teamAllowed = allCategories.filter((category) => {
            if (category.attachTeamMembers || category.attachTeamCaptains) {
                return true;
            }
            return false;
        });
        return teamAllowed;
    }

    // removes all categories, causes redirect to form closed
    if (!enableIndividualRegistration && !enableTeams) {
        return [];
    }
    // return empty array if none of the conditions apply
    return [];
};

const initialState = eventLevelCategoryFilter();

export const slice = createSlice({
    name: "categories",
    initialState,
    reducers: {
        updateCategories: (state, action) => action.payload,
    },
});

// actions
export const { updateCategories } = slice.actions;

// selectors

// same as getCategories
export const selectAllCategories = (state) => state.categories;

export default slice.reducer;
